import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import ProductVariationsProp from '../../propTypes/productVariationsProp';
import Select from '../../../../commonComponents/forms/inputs/Select';

function CartSubscriptionSelector(props) {
  const { t, product, onUpdateProductFrequency } = props;
  const {
    id,
    availableSubscriptionFrequency,
    availableForSubscription,
    frequency: productFrequency,
  } = product;

  if (!availableForSubscription) {
    return null;
  }

  const items = useMemo(
    () =>
      availableSubscriptionFrequency.map(frequency => ({
        id: frequency,
        text: t(`shop.product.subscription.frequency.${frequency}`),
      })),
    [availableSubscriptionFrequency],
  );
  return (
    <div className="available-frequency-selector">
      <Select
        onChange={value =>
          onUpdateProductFrequency(id, productFrequency)(value)
        }
        id={`availableFrequencies_${id}`}
        items={items}
        value={productFrequency}
        searchable={false}
        allowClear={false}
      />
    </div>
  );
}

CartSubscriptionSelector.propTypes = {
  t: PropTypes.func.isRequired,
  onUpdateProductFrequency: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductVariationsProp.propType).isRequired,
};

export default translate(CartSubscriptionSelector);
